const wortHost = 'dev.wort.lu';
const luxtimesHost = 'dev.luxtimes.lu';
const mywortHost = 'dev.mywort.lu';
//const ssoHost = 'sp-sso-dev.wort.lu';

const APP_CONF = {
    //domain                  : '.wort.lu',
    //host                    : wortHost,
    webHost_wort            : `https://${wortHost}`,
    webHost_luxtimes        : `https://${luxtimesHost}`,
    mywortWebHost           : `https://${mywortHost}`,
    myWort                  : `https://${mywortHost}/mywort`,

    //ssoHost                 : `https://${ssoHost}`,
    googleMapApiKey         : "AIzaSyD6-3zWECLefyBT6PnLMCQAr9P6d0bhR78",
    //twitterId               : "00651d",

    latinaWebsocketHost     : `wss://${wortHost}`,
    latinaStream            : "https://ice.creacast.com/radio-latina-lu-mp3",

    firebaseConfig : {
        apiKey: "AIzaSyAS662-Wrr743vBoJRbl8P_HCkiGOmdZGs",
        authDomain: "wortv4-test-72f9a.firebaseapp.com",
        databaseURL: "https://wortv4-test-72f9a.firebaseio.com",
        projectId: "wortv4-test-72f9a",
        storageBucket: "wortv4-test-72f9a.appspot.com",
        messagingSenderId: "360326138301",
        appId: "1:360326138301:web:778d4fbd086acfa26c2ad4",
        measurementId: "G-8T49SQP89H"
    },
    firebasePublicVapidKey: "BCr3czlISpCfEw-_VuKPLHl0gqnyCE1Lzd7x8ylv_FG6qCLStYQsLYJimgFl0bA_j0nReuanGKv-cjd5KUmbZag",
    firebaseAppId           : "wort-v5-dev"
};
module.exports = APP_CONF;



// WEBPACK FOOTER //
// ../conf/dev.js